import {components} from "react-select";
import React from "react";
import styled from "@emotion/styled";

const TextAndInputWrapper = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;

// Block container — text-overflow: ellipsis only works on block/inline-block, not flex
const EllipsisText = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
`;

const PillarIcon = styled.img`
    width: 14px;
    height: 14px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 4px;
`;

const LabelText = styled.span`
    vertical-align: middle;
`;

export const CustomValueContainer = ({children, selectProps, getValue, hasValue, ...props}) => {
    const values = getValue();
    const childArray = React.Children.toArray(children);
    // The Input element is always the last child in react-select
    const input = childArray[childArray.length - 1];

    if (!hasValue) {
        return (
            <components.ValueContainer {...props} selectProps={selectProps} getValue={getValue} hasValue={hasValue}>
                {children}
            </components.ValueContainer>
        );
    }

    const tooltipText = values.map(v => v.label).join(', ');

    return (
        <components.ValueContainer {...props} selectProps={selectProps} getValue={getValue} hasValue={hasValue}>
            {/*
              * TextAndInputWrapper is the ONLY flex child of ValueContainer so it claims
              * the full available width. Moving {input} inside it prevents react-select's
              * Input (which also has flex:1) from competing for space and cutting
              * the visible text prematurely.
              */}
            <TextAndInputWrapper title={tooltipText}>
                <EllipsisText>
                    {values.map((v, i) => {
                        const pillar = selectProps.categoryData?.find(bp => bp.id === v.value);
                        return (
                            <span key={v.value}>
                                {i > 0 && ', '}
                                {pillar?.icon && <PillarIcon src={pillar.icon} alt=""/>}
                                <LabelText>{v.label}</LabelText>
                            </span>
                        );
                    })}
                </EllipsisText>
                {/* Input lives here so it doesn't split width with the text */}
                {input}
            </TextAndInputWrapper>
        </components.ValueContainer>
    );
};